import React from 'react';
import './popup.scss';

/**
 * Shared popup primitives — apply consistent styling to any menu/popover content.
 * Pair these with ButtonWithPopup or any container that wants the same look.
 */

export const PopupContent = ({ children, style, className = '' }) => (
  <div className={`popup-content ${className}`} style={style}>
    {children}
  </div>
);

export const PopupSection = ({ title, children, style, className = '' }) => (
  <div className={`popup-section ${className}`} style={style}>
    {title && <div className="popup-section__title">{title}</div>}
    {children}
  </div>
);

export const PopupSectionTitle = ({ children, style, className = '' }) => (
  <div className={`popup-section__title ${className}`} style={style}>
    {children}
  </div>
);

export const PopupDivider = ({ style, className = '' }) => (
  <div className={`popup-divider ${className}`} style={style} aria-hidden="true" />
);

export const PopupEmpty = ({ children = 'No results', style, className = '' }) => (
  <div className={`popup-empty ${className}`} style={style}>
    {children}
  </div>
);

/**
 * PopupOption — clickable row with optional icon + title/subtitle.
 *
 *   <PopupOption icon={<Icon/>} title="My Profile" subtitle="@joe" onClick={...} />
 *
 * For simple text rows, just pass `title` (or use a single `children` string).
 */
export const PopupOption = ({
  icon,
  title,
  subtitle,
  variant = 'default',
  onClick,
  disabled = false,
  children,
  style,
  className = '',
}) => {
  const classes = [
    'popup-option',
    variant === 'danger' ? 'popup-option--danger' : '',
    className,
  ].filter(Boolean).join(' ');

  const body = title || subtitle ? (
    <div className="popup-option__body">
      {title && <div className="popup-option__title">{title}</div>}
      {subtitle && <div className="popup-option__subtitle">{subtitle}</div>}
    </div>
  ) : (
    <div className="popup-option__body">
      <div className="popup-option__title">{children}</div>
    </div>
  );

  return (
    <button
      type="button"
      className={classes}
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
      style={style}
    >
      {icon && <span className="popup-option__icon">{icon}</span>}
      {body}
    </button>
  );
};
